module.exports = __webpack_public_path__ + "static/media/geral1.fe068ed3.png";